<template>
    <div id="bene-mobile-phone-container" class="mt-sm" :class="showFormInput.contact.mobileNo ? '' : ' hide' ">
        <f7-list class="form-group">
            <f7-list-input
                id           ="mobileNoListId"
                input-id     ="mobileNo"
                name         ="mobileNo"
                type         ="tel"
                class        ="mobile-input"

                v-if         ="showFormInput.contact.mobileNo"
                :label       ="mobileNoLabel"
                placeholder  =""
                :value       ="mobileNo"
                @change      ="setMobileNo($event.target.value); validateInput($event.target); setInput($event.target);"

                autocomplete ="off"
                maxlength    ="15"
                outline
                floating-label
                clear-button
            >
                <f7-link id="beneMobileCountryCode" popover-open=".popover-mobile-no" slot="content-start" class="flag-with-chevron">
                    <img :src="getFlagImg(mobileIDD)" class="" loading="lazy"/>
                    <span class="">{{ mobileIDDCode }}</span>
                </f7-link>
            </f7-list-input>
        </f7-list>

        <BeneficiaryMobilePhonePopover />
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    // import BeneficiaryMobilePhonePopover from '../components/beneficiary-mobile-phone-popover.vue';
    export default {
        props: {
        },
        mounted() {
        },
        data: function() {
            return {}
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'countryCodeList',
                'mobileNoLabel',
                'mobileNo',
                'mobileIDD',
                'mobileIDDCode'
            ])
        },
        components: {
            BeneficiaryMobilePhonePopover: () => import('../components/beneficiary-mobile-phone-popover.vue')
        },
        methods: {
            ...mapActions('beneficiary', [
                'setMobileNo',
            ]),

            validateInput(inputEl){
                this.$emit("validateInput", inputEl);
            },

            setInput(inputEl){
                this.$emit("setInput", inputEl);
            }
        }
    }
</script>